// Load plugins
import helper from "./helper";
import * as Popper from "@popperjs/core";

// Set plugins globally
window.helper = helper;
window.Popper = Popper;
